module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_VN.296f7618.jpg";